import * as Effect$dClass from "../Effect.Class/index.js";
import * as Effect$dUncurried from "../Effect.Uncurried/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
const $$new = /* #__PURE__ */ Specular$dRef.new(Effect$dClass.monadEffectEffect);
const subscribeToChanges = (dyn, f) => {
  const $0 = Effect$dUncurried.runEffectFn1(f);
  return Specular$dFRP$dBase._subscribeEvent($0, dyn);
};
const subscribe = (dyn, f) => {
  const $0 = Effect$dUncurried.runEffectFn1(f);
  const unsub = Specular$dFRP$dBase._subscribeEvent($0, dyn);
  const currentValue = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(dyn)();
  f(currentValue);
  return unsub;
};
const readDynamic = $0 => Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)($0)();
const pureDynamic = /* #__PURE__ */ (() => Specular$dFRP$dBase.applicativeDynamic.pure)();
const newDynamic = initialValue => {
  const ref = $$new(initialValue)();
  return {dynamic: ref._1, set: x => ref._2(_old => x)()};
};
export {$$new as new, newDynamic, pureDynamic, readDynamic, subscribe, subscribeToChanges};
